<div class="container-fluid footer-minus pull-left">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 text-center">
                <div>Copyright © 2021 | Developed by NowNow digital systems.</div>
            </div>
        </div>
    </div>
</div> 